import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryMonitor} from "@/service/monitor.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";
import {MonitorTable} from "@/widget/CommonDetail/MonitorTable";

export const ViewMonitor: FC = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: monitorData, isLoading: monitorLoading} = useQueryMonitor({id: drawerId!}, isNumber(drawerId))
    const monitor = monitorData?.data
    return <> <ResultWrapper isLoading={monitorLoading} isEmpty={isEmpty(monitor)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'专利名称'} content={monitor?.patentName}/>
                <GridItem title={'申请类型'} content={monitor?.category}/>
                <GridItem title={'申请号/专利号'} content={monitor?.applyNo}/>
                <GridItem title={`申请日期`} content={formatTime('D', monitor?.applyDate)}/>
                <GridItem title={'案件状态'} content={monitor?.patentStatus}/>
                <GridItem title={`费减比例`} content={monitor?.retard}/>
                {/*<GridItem title={`撰稿人`} content={monitor?.writer}/>*/}
                <GridItem title={'客户名称'} content={monitor?.customerName}/>
                <GridItem title={'业务人员'} content={monitor?.seller}/>
                <MonitorTable data={monitor?.monitors}/>

            </Grid>
        </Stack></ResultWrapper>
    </>
}